import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  props: {
    width: {
      type: String,
      default: "w-50 m-auto",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Paginate,
  },
  data() {
    return {
      busy: false,
      textInput: "",
      apiStatus: "ไม่พบข้อมูล",
      sortBy: "document_no",
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      totalItem: 0,
      fields: [
        {
          key: "document_no",
          label: "เลขที่ใบวางบิล",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2 py-1.5",
          sortable: true,
        },
        {
          key: "customer_name",
          label: "ลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2 py-1.5",
          sortable: true,
        },
        {
          key: "total_price",
          label: "ยอดเต็ม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-black td-top text-left text-xs-1/2 py-1.5",
          sortable: true,
        },
        {
          key: "remaining_amount",
          label: "ยอดคงค้าง",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-black td-top text-left text-xs-1/2 py-1.5",
          sortable: true,
        },
        {
          key: "action",
          label: "#",
          thClass: "font-weight-bold text-right text-xs-1/2",
          tdClass: "text-gray-400 td-top text-right text-xs-1/2 py-1.5",
        },
      ],
      items: [],
    };
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.items = [];
        this.onSearchHandler(1);
      }
    },
  },
  methods: {
    getCompanyName(item) {
      return (
        item?.customer?.company_name ||
        item?.customer_detail?.company_name ||
        item?.customer?.name ||
        item?.customer_detail?.name ||
        item?.bill_customer_name ||
        "-"
      );
    },
    getCustomerName(item) {
      return (
        item?.customer?.name ||
        item?.customer_detail?.name ||
        item?.bill_customer_name ||
        "-"
      );
    },
    getTotalPrice(item) {
      return (
        item?.total_price ??
        item?.grandtotal ??
        ((parseFloat(item?.bill_before_vat || 0) + parseFloat(item?.bill_value_added_tax || 0)) || 0)
      );
    },
    getTotalPaid(item) {
      return (
        item?.total_paid ??
        item?.paid_total ??
        item?.paid_amount ??
        item?.payment_total ??
        item?.amount_paid ??
        0
      );
    },
    getRemainingAmount(item) {
      const totalPrice = Number(this.getTotalPrice(item) || 0);
      const totalPaid = Number(this.getTotalPaid(item) || 0);
      const remaining = totalPrice - totalPaid;
      return remaining > 0 ? remaining : 0;
    },
    onSelected(item) {
      this.$emit("onDocumentCloseHandler", {
        status: true,
        data: item,
      });
    },
    onClose() {
      this.$emit("onDocumentCloseHandler", {
        status: false,
      });
    },
    async onSearchHandler(currentPage) {
      try {
        this.busy = true;
        const page = currentPage || 1;
        this.apiStatus = "กำลังค้นหาข้อมูล..";

        const result = await Vue.prototype.$axios.get(
          `${Vue.prototype.$host}/api/v1/billing_notes?page=${page}&perPage=8&keyword=${encodeURIComponent(this.textInput)}`
        );

        setTimeout(() => {
          this.busy = false;
          this.apiStatus = "ไม่พบข้อมูล";
          this.currentData = result?.data || {};
          this.items = result?.data?.data || [];
          this.totalItem = result?.data?.total || this.items.length;
        }, 300);
      } catch (error) {
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler(error?.response?.data?.message || error.message);
      }
    },
  },
};
